import { render, staticRenderFns } from "./v-footer-headline.vue?vue&type=template&id=2a9b7bfc&"
import script from "./v-footer-headline.vue?vue&type=script&lang=js&"
export * from "./v-footer-headline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports